<template>
<div>
	<uninstallDialog ref="uninstallRef"></uninstallDialog>
</div>
</template>

<script setup>
import uninstallDialog from './uninstallDialog.vue';
import orderApi from '../../api/order/index.js';
import { $getLocalStorage, $setLocalStorage } from '@shining3d/common-module/utils/index.js';
import { ref } from 'vue';

// 去打印
const handlePrintOut = ( data ) => {
	orderApi.dentalxGenerateDesignSecret( data ).then(( res ) => {
		if ( res.status === 'success' ) {
			const { secret } = res.result;
			const action = data.fileID?.length === 1 ? 'downloadOrderDesignFile' : 'cloudFileDownloadUrlV2';
			const hrefParams = `CallAccuWareFromCloud://action=${action}&secret=${secret}`;
			const link = document.createElement( 'a' );
			link.href = hrefParams;
			// 未检测到Accuware
			link.addEventListener( 'click', ( e ) => {
				console.log( '监听link111' );
				openAccuware( 'accuware' );
			});
			link.click();
		}
	});
};

const openAccuware = ( softname ) => {
	const startTime = Date.now();
	const t = setTimeout(() => {
		const uninstallIsShow = ref( Boolean( $getLocalStorage( 'uninstallIsShow' )));
		const endTime = Date.now();
		console.log( '监听link333', startTime, endTime, endTime - startTime );
		if ( !startTime || endTime - startTime < 600 + 200 ) {
			if ( !uninstallIsShow.value ) {
				console.log( '软件不存在' );
				handleUninstall( softname );
			}
		}
	}, 600 );
	// 窗口失去焦点时触发
	window.onblur = function () {
		console.log( '失焦111' );
		clearTimeout( t );
		$setLocalStorage( 'uninstallIsShow', true );
	};
};

// 本地未检测到Accuware提示
const uninstallRef = ref( null );
const handleUninstall = ( softname ) => {
  if( uninstallRef.value ){
    uninstallRef.value.open({ softwareName: softname });
  }	
};

defineExpose({ handlePrintOut })

</script>

<style scoped lang="scss">

</style>
